import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Share from './Share'

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Share)



// WEBPACK FOOTER //
// ./src/views/Share/index.js